// The server's trusted-device cookie is HttpOnly and host-only, and it holds an
// opaque 256-bit token the browser never sees. This app used to ALSO write a
// cookie of the same name, for the whole registrable domain, holding the 6-digit
// verification code -- back when that code was what the platform stored as the
// device. It no longer is, so the value matches nothing; worse, the Cookie header
// then carries two cookies of that name and the wrong one can win, which is what
// made "trust this device" ask for a code on every single sign-in.
//
// Nothing writes it any more (see Login.js / useAuth.js). This clears the ones
// already sitting in people's browsers, which would otherwise keep shadowing the
// real cookie for up to 31 days. Scoped to the domain the script wrote them on:
// a host-only cookie of the same name is a DIFFERENT cookie and is left alone --
// and the server's is HttpOnly, so document.cookie cannot reach it regardless.
export const clearLegacyTrustedDeviceCookies = (domain = "lucashealth.ai") => {
  try {
    const names = document.cookie
      .split(";")
      .map((c) => c.split("=")[0].trim())
      .filter((name) => name.startsWith("trustedDeviceCode-"));

    for (const name of new Set(names))
      document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + domain;
  } catch (e) {
    // Storage unavailable (private mode, embedded webview): nothing to clean up.
  }
};
